import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useI18n } from "../../i18n";

/** Any address the app doesn't know. */
const NotFoundPage: React.FC = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <h1 className="text-3xl font-bold tracking-tight">{t.common.notFound.title}</h1>
      <p className="max-w-md text-muted-foreground">{t.common.notFound.description}</p>
      <Button onClick={() => navigate("/")}>{t.common.notFound.home}</Button>
    </div>
  );
};

export default NotFoundPage;
